import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Table,
  Divider,
  Dropdown,
  Modal,
  MenuProps,
  Popover,
  Image,
  DatePicker,
  Select,
} from "antd";
// import type { MenuProps } from "antd";
import {
  MoreOutlined,
  PrinterOutlined,
  EditOutlined,
  DeleteOutlined,
  FilePdfOutlined,
  ReloadOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  CheckOutlined,
  AlertOutlined,
  ContainerFilled,
  FilterOutlined,
} from "@ant-design/icons";
import {
  getBillsService,
  getSupplierService,
  getPurchaseService,
  getMaterialService,
  getMetalsService,
  getBillPDF,
  getSuppliersService,
  deleteBillService,
} from "./BillsPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./BillsPage.css";
import Loader from "../../components/Loader/Loader";
import printJS from "print-js";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import Cookies from "universal-cookie";
import dayjs from "dayjs";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Content } = Layout;

export interface BillsPageProps {}

const BillsPage = (props: BillsPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [billsList, setBillsList] = useState([]) as any;
  const [billDetailsTable, setBillDetailsTable] = useState([]) as any;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [billToDelete, setBillToDelete] = useState({}) as any;
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [printBillData, setPrintBillData] = useState(null) as any;
  const [suppliers, setSuppliers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalBills, setTotalBills] = useState(0);
  const [billDetailsTableData, setBillDetailsTableData] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [suppliersSelectedOptions, setSuppliersSelectedOptions] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]) as any;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]) as any;
  const [suppliersOptions, setSuppliersOptions] = useState([]) as any;
  const [isFilteredData, setIsFilteredData] = useState(false);
  let navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const billColumns = [
    {
      title: "Item Number",
      key: "itemNumber",
      align: "center",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Purchase Date",
      key: "date",
      align: "center",
      render: (record: any) => new Date(record.purchaseCreatedTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Purchase Time",
      key: "time",
      align: "center",
      render: (record: any) =>
        new Date(record.purchaseCreatedTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Bill Number",
      dataIndex: "billNumber",
      key: "billNumber",
    },
    {
      title: "Supplier",
      key: "supplier",
      render: (record: any) => getSupplierDisplayName(record.supplierID),
    },
    {
      title: <span style={{ paddingRight: "0px" }}>Total Net Weight (kg)</span>,
      key: "totalNetWeight",
      align: "center",
      render: (record: any) =>
        record.totalNetWeight ? (
          <strong style={{ marginRight: "10px" }}>{Number(record.totalNetWeight).toFixed(1)}</strong>
        ) : (
          ""
        ),
    },
    {
      title: <span style={{ paddingRight: "0px" }}>Materials Info</span>,
      key: "totalNumMaterials",
      align: "center",
      render: (record: any) => (record.totalNumMaterials ? `${record.totalNumMaterials} materials` : ""),
    },
    {
      title: "Transaction Type",
      key: "transactionType",
      align: "center",
      render: (record: any) => {
        return record.smallTransaction ? (
          "Small"
        ) : (
          <>
            <ContainerFilled style={{ marginRight: "5px", color: "#283555" }} />
            Bill
          </>
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: <span style={{ paddingRight: "0px" }}>Total Bill Amount (RM)</span>,
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "right",
      render: (totalAmount: string) => (
        <strong style={{ marginRight: "10px" }}>{Number(totalAmount).toFixed(2)}</strong>
      ),
    },
    {
      title: "Bill Completed",
      dataIndex: "completed",
      align: "center" as const,
      render: (record: any) =>
        record ? (
          <>
            <CheckOutlined style={{ color: "green", marginRight: "5px" }} /> Yes
          </>
        ) : (
          <>
            <AlertOutlined style={{ color: "orange", marginRight: "5px" }} />
            No
          </>
        ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
    },
    {
      title: "Print Bill",
      key: "printBill",
      align: "center",
      render: (record: any) =>
        record.completed ? (
          <Button type="primary" size="small" onClick={() => printBill(record)} icon={<PrinterOutlined />}>
            Print Bill
          </Button>
        ) : null,
    },
    {
      title: "Created Date",
      key: "date",
      align: "center",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Created Time",
      key: "time",
      align: "center",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Options",
      key: "options",
      align: "center",
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        if (record.completed) items.push({ key: "print", label: "Print Bill", icon: <PrinterOutlined /> });
        record.completed && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Bill", icon: <DollarOutlined /> })
          : items.push({ key: "edit", label: "Edit Bill", icon: <EditOutlined /> });
        items.push({ key: "purchase", label: "View Purchase", icon: <FolderOpenOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Bill", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editBill(record);
                else if (key === "delete") openDeleteBillModal(record);
                else if (key === "print") printBill(record);
                else if (key === "purchase") viewPurchase(record.purchaseID);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const billDetailsColumns = [
    {
      title: "Item Number",
      key: "itemNumber",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Images",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            wrapperStyle={{ marginRight: "10px" }}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => record.displayName,
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(1),
    },
    {
      title: "Price (RM/kg)",
      key: "cashAmount",
      align: "right" as const,
      render: (record: any) => Number(record.price).toFixed(2),
    },
    {
      title: "Amount (RM)",
      key: "amount",
      align: "right" as const,
      render: (record: any) => Number(Number(record.price) * Number(record.netWeight)).toFixed(2),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getSuppliers();
    getMetals();
  }, []);

  useEffect(() => {
    getBills(currentPage, suppliersSelectedOptions, dateRangeFilter);
  }, [currentPage]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const getBills = async (pageNumber: Number, suppliersFilter: String, dateRangeFilter: String[]) => {
    try {
      setLoading(true);
      const filters = {
        suppliers: suppliersFilter,
        startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
        endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      };
      const resBill = await getBillsService(currOffice, String(pageNumber), filters);
      setTotalPages(resBill.data.totalPages);
      setTotalBills(resBill.data.totalBills);
      const currBills: any[] = [];
      for (let bill of resBill.data.bills) {
        bill.key = bill.billID;
        // const purchaseID = bill.purchaseID;
        // const resPurchase = await getPurchase(purchaseID);
        // bill.materialIDList = resPurchase?.data.materialIDList;
        currBills.push(bill);
      }
      setBillsList([...currBills]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBills error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getPurchase = async (purchaseID: string) => {
    try {
      setLoading(true);
      const res = await getPurchaseService(currOffice, purchaseID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSuppliers = async () => {
    try {
      setLoading(true);
      const res = await getSuppliersService();
      const suppliersData =
        currOffice === "pg" ? res.data.pgSuppliers : currOffice === "bw" ? res.data.bwSuppliers : [];
      setSuppliers(suppliersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSupplierDisplayName = (supplierID: any) => {
    const supplierInfo = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    let supplierDisplayInfo = "";
    let popoverContent = <></>;
    if (
      supplierInfo !== undefined &&
      supplierInfo["companyName"] !== undefined &&
      supplierInfo["companyName"] !== "" &&
      supplierInfo["name"] !== undefined &&
      supplierInfo["name"] !== ""
    ) {
      supplierDisplayInfo = supplierInfo["companyName"] + " (" + supplierInfo["name"] + ")";
      popoverContent = (
        <div>
          <p>Name: {supplierInfo["name"]}</p>
          <p>Company: {supplierInfo["companyName"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (
      supplierInfo !== supplierInfo &&
      supplierInfo["companyName"] !== undefined &&
      supplierInfo["companyName"] !== ""
    ) {
      supplierDisplayInfo = supplierInfo["companyName"];
      popoverContent = (
        <div>
          <p>Company: {supplierInfo["companyName"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (supplierInfo !== undefined && supplierInfo["name"] !== undefined && supplierInfo["name"] !== "") {
      supplierDisplayInfo = supplierInfo["name"];
      popoverContent = (
        <div>
          <p>Name: {supplierInfo["name"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    }
    return <Popover content={popoverContent}>{supplierDisplayInfo}</Popover>;
  };

  const formatBillSupplierFileName = (supplierID: string, billNumber: string, billID: string) => {
    const supplierInfo: any = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    const supplierName = supplierInfo.companyName ? supplierInfo.companyName : supplierInfo.name;
    return `bill_${supplierName}_${billNumber}_${billID}.pdf`.replaceAll(" ", "_");
  };

  const printBill = async (record: any) => {
    try {
      setLoading(true);
      const fileName = formatBillSupplierFileName(record.supplierID, record.billNumber, record.billID);
      const res = await getBillPDF(fileName);
      setPrintBillData(res.data);
      setIsPDFModalOpen(true);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("printBillButton error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const viewPurchase = (purchaseID: string) => {
    navigate(`/purchase/${purchaseID}`);
  };

  const editBill = (record: any) => {
    navigate(`/bill/${record.billID}`);
  };

  const getBillExpandedDetails = async (billID: string) => {
    try {
      setLoading(true);
      const currBill = billsList.find((bill: any) => bill.billID === billID);
      const purchaseInfo = await getPurchase(currBill.purchaseID);
      const currMaterials: any[] = [];
      for (let materialID of purchaseInfo.materialIDList) {
        const resMaterial: any = await getMaterial(materialID);
        const materialData = resMaterial.data;
        materialData.key = materialData.materialID;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        currMaterials.push(materialData);
      }
      const newBillDetails = [...billDetailsTableData];
      const newBillDetailsObject = {
        billID: billID,
        materialsList: currMaterials,
      };
      newBillDetails.push(newBillDetailsObject);
      setBillDetailsTableData([...newBillDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBillExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const formatBillMaterialList = (billDetails: any) => {
    let billMaterialList: any[] = [];
    billDetails.materialsList.forEach((material: any) => {
      const materialIfExists = billMaterialList.find((billMaterial: any) => material.metalID === billMaterial.metalID);
      if (materialIfExists) {
        materialIfExists.netWeight = (Number(materialIfExists.netWeight) + Number(material.netWeight)).toFixed(1);
      } else {
        billMaterialList.push({ ...material });
      }
    });
    return [...billMaterialList];
  };

  const displayBillDetails = (billID: string) => {
    const currBill = billsList.find((bill: any) => bill.billID === billID);
    const currBillDetails = billDetailsTableData.find((bill: any) => bill.billID === billID);
    if (currBillDetails === undefined || currBillDetails === null) return <></>;
    return (
      <Row justify="center">
        <Col span={16}>
          <Table dataSource={formatBillMaterialList(currBillDetails)} columns={billDetailsColumns} pagination={false} />
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>
              <strong>Payment Method</strong>
              {currBill.paymentMethod === "Cash" && <Row>Cash: RM {Number(currBill.cashAmount).toFixed(2)}</Row>}
              {currBill.paymentMethod === "Online" && <Row>Online: RM {Number(currBill.onlineAmount).toFixed(2)}</Row>}
              {currBill.paymentMethod === "Cash + Online" && (
                <>
                  <Row>Cash: RM {Number(currBill.cashAmount).toFixed(2)}</Row>
                  <Row>Online: RM {Number(currBill.onlineAmount).toFixed(2)} </Row>
                </>
              )}
            </Col>
            <Col span={12}>
              <Row justify="end">
                {/* <h4 style={{ fontStyle: "italic", color: "grey" }}>
                  Total Bill Amount: RM {Number(currBill.totalAmount).toFixed(2)}
                </h4> */}
                <h4>
                  <strong>Total Payment Amount: RM {Number(currBill.totalAmount).toFixed(2)}</strong>
                </h4>
              </Row>
            </Col>
          </Row>
          {currBill.notes && (
            <>
              <Row style={{ margin: "10px 0" }}>
                <strong>Notes</strong>
              </Row>
              <Row>{currBill.notes}</Row>
            </>
          )}
        </Col>
      </Row>
    );
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const openDeleteBillModal = (record: any) => {
    setBillToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteBill = async () => {
    //call api to delete
    setIsDeleteModalOpen(false);
    await deleteBill(billToDelete.billID);
    await getBills(currentPage, suppliersSelectedOptions, dateRangeFilter);
  };

  const deleteBill = async (billID: string) => {
    try {
      setLoading(true);
      const res = await deleteBillService(billID);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteBill error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const declineDeleteBill = () => {
    setIsDeleteModalOpen(false);
  };

  const closePDFModal = () => {
    setIsPDFModalOpen(false);
  };

  const printBillPDF = () => {
    printJS({ printable: encodeURI(printBillData), type: "pdf", base64: true });
  };

  const confirmFilterMaterials = async () => {
    setIsFilterModalOpen(false);
    await getBills(1, suppliersSelectedOptions, dateRangeFilter);
    setIsFilteredData(true);
  };

  const cancelFilterMaterials = () => {
    setIsFilterModalOpen(false);
  };

  const openFilterModal = () => {
    getSuppliersFilterOptions();
    setIsFilterModalOpen(true);
  };

  const resetFilters = async () => {
    setSuppliersSelectedOptions("");
    setDateRangeFilter([]);
    setDateRangeValue([null, null]);
    await getBills(1, "", []);
    setIsFilterModalOpen(false);
    setIsFilteredData(false);
  };

  const updateSupplierFilter = (value: any) => {
    setSuppliersSelectedOptions(value);
  };

  const getSelectedSuppliersValue = () => {
    if (suppliersSelectedOptions === "") return [];
    return suppliersSelectedOptions;
  };

  const updateDateRangeFilter = (dateRange: string[]) => {
    setDateRangeValue([dayjs(dateRange[0], "YYYY-MM-DD"), dayjs(dateRange[1], "YYYY-MM-DD")]);
    setDateRangeFilter(dateRange);
  };

  const getSuppliersFilterOptions = () => {
    const options: any = [];
    suppliers.forEach((supplier: any) => {
      options.push({
        value: supplier.supplierID,
        label:
          supplier.companyName !== "" && supplier.companyName !== undefined
            ? `${supplier.companyName} ( ${supplier.name} )`
            : `${supplier.name}`,
      });
    });
    setSuppliersOptions(options);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="bills-title">Bills</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => openFilterModal()}
                    icon={<FilterOutlined />}
                    style={{
                      marginTop: "20px",
                      marginRight: "10px",
                      color: isFilteredData ? "white" : "",
                      backgroundColor: isFilteredData ? "#283555" : "",
                    }}
                  ></Button>
                  <Button
                    type="default"
                    onClick={() => {
                      resetFilters();
                    }}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              dataSource={[...billsList]}
              columns={billColumns}
              pagination={{
                pageSize: 20,
                total: totalBills,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getBills(page, suppliersSelectedOptions, dateRangeFilter);
                },
              }}
              expandedRowRender={(record: any) => displayBillDetails(record.billID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getBillExpandedDetails(record.billID);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Delete Bill"
        open={isDeleteModalOpen}
        okText="Confirm"
        okType="danger"
        onOk={confirmDeleteBill}
        onCancel={declineDeleteBill}
      >
        <p>
          Are you sure you want to delete this bill from
          <strong>{billToDelete.supplierName}</strong> on{" "}
          <strong>{new Date(billToDelete.createdTimestamp).toLocaleDateString("en-GB")}</strong>?
        </p>
        <p>This will permanently delete this bill and this action cannot be undone.</p>
      </Modal>
      <Modal
        title="Bill PDF"
        style={{ height: "600px" }}
        open={isPDFModalOpen}
        okText="Print"
        onOk={printBillPDF}
        onCancel={closePDFModal}
      >
        <iframe
          title="printBill"
          id="printBill"
          src={`data:application/pdf;base64, ${encodeURI(printBillData)}`}
          height="500px"
          width="100%"
        ></iframe>
      </Modal>
      <Modal
        title="Filter Purchases"
        open={isFilterModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={cancelFilterMaterials}
      >
        <Row>
          <Col span={24}>
            <Row style={{ marginBottom: "10px" }}>Suppliers:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <Select
                showSearch
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Select suppliers"
                value={getSelectedSuppliersValue()}
                onChange={updateSupplierFilter}
                options={suppliersOptions}
                filterOption={(input: any, option: any) => {
                  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              />
            </Row>
            <Row style={{ marginBottom: "10px" }}>Date Range:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <RangePicker
                style={{ width: "100%" }}
                // defaultValue={[null, null]}
                // value={[null, null]}
                value={dateRangeValue}
                onChange={(value, dateString: string[]) => {
                  updateDateRangeFilter(dateString);
                }}
                disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                  return current && current > moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Row>
            <Row justify="center" style={{ margin: "30px 0" }}>
              <Button onClick={() => resetFilters()} style={{ marginRight: "20px" }}>
                Reset Filters
              </Button>
              <Button type="primary" onClick={() => confirmFilterMaterials()}>
                Filters Purchases
              </Button>
            </Row>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default BillsPage;
